export default "/static/featured/tcm.jpg"